module.exports = __webpack_public_path__ + "static/media/iconFB.c14da210.svg";